import { createPortal } from "react-dom";

const Tooltip = ({ children, targetRect }) => {
    if (!targetRect) return null;
    return createPortal(
        <div
            className="fixed px-2 py-1 rounded-md bg-black text-white text-[10px] z-50"
            style={{
                top: targetRect.top - 30,
                left: targetRect.left + targetRect.width / 2,
                transform: "translateX(-50%)",
            }}
        >
            {children}
        </div>,
        document.body
    );
};

export default Tooltip